export default {
  banners: [
    {
      img: '/images/banner.jpg',
      title: '',
      // description: 'Hormigones, calzadas y aceras, carpetas asfalto'
    },
    {
      img: '/images/banner.jpg',
      title: 'CALIDAD, COMPROMISO y RESPONSABILIDAD',
      // description: 'Hormigones, calzadas y aceras, carpetas asfalto'
    }
    // {
    //   img: '/images/banner2.png',
    //   title: 'Proyectos de Ingeniería en Obras Civiles',
    //   description: 'Soleras, baldosas, adoquines y pavimentos de piedra'
    // },
    // {
    //   img: '/images/banner3.png',
    //   title: 'Proyectos de Ingeniería en Obras Viales y Obras Civiles',
    //   description: 'Excavaciones y mejoramiento de terrenos'
    // },
    // {
    //   img: '/images/banner4.png',
    //   title: 'Proyectos de Ingeniería en Obras Viales y Obras Civiles',
    //   description: 'Proyectos: Medidas de Mitigaciones, Serviu, EISTU y ABV, aguas lluvias, demarcación y señalización vial, canalizaciones y refuerzos tuberías, cámaras de servicios y sumideros, levantamientos topográficos, OOCC en semaforizaciones.'
    // },
    // {
    //   img: '/images/banner5.png',
    //   title: 'La confianza de un trabajo bien realizado',
    //   description: 'Calidad, seguridad y compromiso'
    // }
  ]
};



// WEBPACK FOOTER //
// ./src/config.banner.js